import React from "react";
import { Icon } from "@commonsku/design-system";
import { GitFork } from "lucide-react";
import { WorkflowAutomationModelType, WorkflowCondition } from "../../../types";
import { WorkflowConfigurationOptions } from "../catalog/configurationOptions";
import AutomationStepPanel from "./AutomationStepPanel";
import { getConditionEditor } from "./condition-editors/conditionEditorRepository";

export interface ConditionsStepProps {
  modelType: WorkflowAutomationModelType;
  conditions: WorkflowCondition[];
  configurationOptions: WorkflowConfigurationOptions;
  onChange: (condition: WorkflowCondition) => void;
}

const ConditionsIcon = () => (
  <Icon ariaHidden as={GitFork} boxSize="6">
    {null}
  </Icon>
);

/**
 * Conditions configuration panel.
 */
export const ConditionsStep = ({
  modelType,
  conditions,
  configurationOptions,
  onChange,
}: ConditionsStepProps) => (
  <AutomationStepPanel
    icon={<ConditionsIcon />}
    stepNumber={2}
    title="Conditions"
  >
    {conditions.map((condition) => {
      const ConditionEditor = getConditionEditor(
        condition.type,
        condition.operator,
      );
      const conditionOption = configurationOptions.condition_options.find(
        (option) =>
          option.model_type === modelType &&
          option.type === condition.type &&
          option.operator === condition.operator,
      );

      if (!ConditionEditor || !conditionOption) {
        return null;
      }

      return (
        <ConditionEditor
          key={condition.workflow_condition_id}
          condition={condition}
          modelType={modelType}
          onChange={onChange}
          option={conditionOption}
        />
      );
    })}
  </AutomationStepPanel>
);

export default ConditionsStep;
